import { AutoMap } from "@automapper/classes"
import { PrelevementDTO } from "./prelevement.dto"

export class AppareilDTO {
    @AutoMap()
    code: string = ''
    @AutoMap()
    type!: number 
    @AutoMap()
    marque?: number
    @AutoMap()
    modele?: number
    @AutoMap()
    numeroInterne: string = ''

}